import { useQuery } from '@tanstack/react-query';

import { getOfferBypassRegionFilterSetting } from '~/services/PromoService';

import { offerBypassRegionFilterQueryKeys } from './offerBypassRegionFilterQueryKeys';

export function useGetOfferBypassRegionFilterSetting(id: string | null) {
  return useQuery({
    queryKey: offerBypassRegionFilterQueryKeys.detail(id ?? ''),
    queryFn: async ({ signal }) => getOfferBypassRegionFilterSetting(id!, { signal }),
    enabled: !!id,
  });
}
